"use client"

import { useInfiniteQuery } from "@tanstack/react-query"

import { Button } from "@/components/ui/button"
import { RestoCard, RestoCardSkeleton } from "@/components/resto-card"
import { getVendorsAction } from "@/app/actions/vendor"

export function CuisineList({ hasGeo }: { hasGeo: boolean }) {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery({
      queryKey: ["vendors-infinite"],
      queryFn: ({ pageParam = 1 }) =>
        getVendorsAction({
          limit: 24,
          page: pageParam,
        }),
      getNextPageParam: (lastPage) => lastPage.next_page || undefined,
      initialPageParam: 1,
    })

  return (
    <div className="flex flex-col gap-6">
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-10 max-md:gap-y-0 md:mt-6 max-md:divide-y-4 max-md:divide-gray-200/50">
        {data?.pages.flatMap(
          (page) =>
            page.data?.map((item) => (
              <RestoCard
                key={item.restaurant_id + item.merchant_id + item.latitude}
                restaurant={item}
                fallbackImage={item.image}
                showDistance={hasGeo}
              />
            )) ?? []
        )}

        {isFetchingNextPage &&
          Array.from({ length: 4 }).map((_, index) => (
            <RestoCardSkeleton key={index} />
          ))}
      </div>
      {hasNextPage && !isFetchingNextPage && (
        <div className="flex justify-center mt-6">
          <Button
            onClick={() => fetchNextPage()}
            disabled={isFetchingNextPage}
            className="min-w-88 border border-blue-500 h-10 rounded-xl text-blue-600 cursor-pointer hover:bg-blue-500 hover:text-white transition-colors duration-300 disabled:opacity-70"
            variant="outline"
          >
            {isFetchingNextPage ? "Đang tải..." : "Xem thêm"}
          </Button>
        </div>
      )}
    </div>
  )
}
